import React, { Component } from 'react';
import { Admin, Resource, defaultTheme, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import { NomenclatoreList, NomenclatoreEdit, NomenclatoreCreate } from './Resources/nomenclatores/nomenclatore';
import { MagmoiList, MagmoiEdit, MagmoiCreate } from './Resources/magmoi/magmois';
import { DeviceList } from './Resources/devices/deviceList';
import { DevicesDaEsaminareList } from './Resources/devices_daesaminare/deviceDaEsaminareList';
import DeviceDaEsaminareEdit from './Resources/devices_daesaminare/deviceDaEsaminareEdit';
import { DevicesScaricatoList } from './Resources/devicesScaricato/deviceScaricatoList';
import DeviceScaricatoEdit from './Resources/devicesScaricato/deviceScaricatoEdit';
import deviceEdit_Admin from './Resources/devices/deviceEdit_Admin';
import DeviceCreate from './Resources/devices/deviceCreate';
import { DeviceLogList } from './Resources/devicelogs/devicelogs';
import jsonServerProvider from './jsonProvider/digigemJsonProvider';
import authProvider from './authProvider';
import icon from '@mui/icons-material/ViewList';
import { SnackbarProvider } from 'notistack';
import DeviceIcon from '@mui/icons-material/Router';
import DeviceLogsIcon from '@mui/icons-material/TrackChanges';
import MagMoisIcon from '@mui/icons-material/LocationCity';
import { FUNCTION_URL } from './Constants/index';
import withAppInsights from './AppInsights';
import CustomLayout from './Layout/CustomLayout';
import Dashboard from './Dashboard';
import deviceEdit from './Resources/devices/deviceEdit';
import AssociazioneMassiva from './Resources/devices/AssociazioneMassiva';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import { it } from './i18n/it';

const myTheme = {
  ...defaultTheme,
  palette: {
    secondary: {
      light: '#5f5fc4',
      main: '#004691',
      dark: '#001064',
      contrastText: '#fff',
    },
    red: {
      main: '#f50057'
    },
    primary: {
      light: '#3F51B5',
      main: '#3F51B5',
      dark: '#001064',
      contrastText: '#fff',
    },
    background: {
      default: "#fafafa",
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "standard",
      },
    },
  },
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        '&$disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
    }
  }
};

// import AutoLogout from './autoLogout';

const dataProvider = jsonServerProvider(FUNCTION_URL);
const i18nProvider = polyglotI18nProvider(() => it, 'it');

class App extends Component {
  render() {
    return (
      <SnackbarProvider>
        <Admin dashboard={Dashboard} title="Digigem-MOI" layout={CustomLayout} theme={myTheme} loginPage={false} authProvider={authProvider} dataProvider={dataProvider} i18nProvider={i18nProvider} >
          <CustomRoutes>
            <Route path="/devices/associazioneMassiva" element={<AssociazioneMassiva />} />
          </CustomRoutes>
          {permissions => [
            <Resource name="devices"
              list={(permissions === 'administrator' || permissions === 'tecnico' || permissions === 'magazziniere' || permissions === 'approvatore' || permissions === 'dg') ? DeviceList : null}
              edit={getDeviceEditType(permissions)}
              create={(permissions === 'administrator' || permissions === 'tecnico' || permissions === 'magazziniere') ? DeviceCreate : null}
              icon={DeviceIcon} />,
            <Resource name="devices_daesaminare"
              list={permissions === 'approvatore' ? DevicesDaEsaminareList : null}
              edit={permissions === 'approvatore' ? DeviceDaEsaminareEdit : null}
              icon={DeviceIcon} />,
            <Resource name="devicesScaricato"
              list={(permissions === 'magazziniere' || permissions === 'approvatore' || permissions === 'dg') ? DevicesScaricatoList : null}
              edit={(permissions === 'administrator' || permissions === 'magazziniere') ? DeviceScaricatoEdit : null}
              icon={DeviceIcon} />,
            <Resource title="Digigem-MOI" name="devicelogs"
              list={(permissions === 'administrator' || permissions === 'tecnico' || permissions === 'magazziniere' || permissions === 'approvatore') ? DeviceLogList : null}
              edit={null}
              create={null}
              icon={DeviceLogsIcon} />,
            <Resource name="nomenclatores"
            list={(permissions === 'administrator' || permissions === 'magazziniere' || permissions === 'approvatore' || permissions === 'dg') ? NomenclatoreList : null}
            edit={permissions === 'administrator' ? NomenclatoreEdit : null}
            create={permissions === 'administrator' ? NomenclatoreCreate : null}
            icon={icon} />,
            <Resource name="magmois"
              list={permissions === 'administrator' || permissions === 'approvatore' ? MagmoiList : null}
              edit={permissions === 'administrator' ? MagmoiEdit : null}
              create={permissions === 'administrator' ? MagmoiCreate : null}
              icon={MagMoisIcon} />,

          ]}
        </Admin>
        {/* <AutoLogout/> */}
      </SnackbarProvider>
    );
  }
}

function getDeviceEditType(permissions) {
  if (permissions === "administrator") {
    return deviceEdit_Admin
  }
  else if (permissions === 'magazziniere' || permissions === 'tecnico' || permissions === 'approvatore') {
    return deviceEdit
  }
  else {
    return null
  }
}

export default withAppInsights(App);